import Amount from "@/models/Shared/Amount";

export default class UpdateInstitutionAccountSettingsRequest {
    transactionLimit: Amount = new Amount();
    dailyLimit: Amount = new Amount();
    oneApprovalThreshold: Amount;
    oneApprovalThresholdActive: boolean = false;
    twoApprovalThreshold: Amount;
    twoApprovalThresholdActive: boolean = false;
    threeApprovalThreshold: Amount;
    threeApprovalThresholdActive: boolean = false;
}